import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIntersectionObserver from 'UIComponents/observer/UIIntersectionObserver';
import ValidI18nMessage from 'ecosystem-marketplace-core/i18n/components/ValidI18nMessage';
import { validUnescapedText } from 'ecosystem-marketplace-core/i18n/utils';
import CollectionRouter from './CollectionRouter';
import AssetResultsSectionDataContainer from '../../../storefront/components/AssetResultsSectionDataContainer';
import { toSearchQuery } from '../../../utils/themeQuery';
import { ThemeQuery } from '../../../records/ThemeQuery';
import { useFetchThemeCollectionOfferingIds } from '../../../themes/hooks/useFetchThemeCollectionOfferingIds';
const MAX_HOME_COLLECTION_COUNT = 3;

const CollectionSection = ({
  className,
  collectionId,
  collectionTagline,
  collectionTitle,
  collectionType,
  linkTo,
  trackInteraction,
  trackPageview
}) => {
  const section = useMemo(() => {
    return `collection::${collectionId}::${collectionType}`;
  }, [collectionId, collectionType]);
  const trackCollectionInteraction = useCallback((action, properties = {}) => {
    trackInteraction(action, Object.assign({}, properties, {
      section,
      type: 'theme'
    }));
  }, [trackInteraction, section]);
  const trackCollectionPageview = useCallback((properties = {}) => {
    trackPageview(Object.assign({}, properties, {
      section,
      type: 'theme'
    }));
  }, [trackPageview, section]);
  const {
    fetchThemeCollectionOfferingIds
  } = useFetchThemeCollectionOfferingIds({
    collectionId
  });
  const searchQuery = useMemo(() => fetchThemeCollectionOfferingIds().then(offeringIds => {
    const themeQuery = new ThemeQuery({
      offeringIds,
      limit: MAX_HOME_COLLECTION_COUNT
    });
    return toSearchQuery(themeQuery);
  }), [fetchThemeCollectionOfferingIds]);
  return /*#__PURE__*/_jsx(UIIntersectionObserver, {
    onIntersectionChange: ({
      entries,
      observer
    }) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
      }
    },
    renderContent: isIntersecting => {
      if (isIntersecting) {
        return /*#__PURE__*/_jsx(AssetResultsSectionDataContainer, {
          className: className,
          maxColumns: MAX_HOME_COLLECTION_COUNT,
          subtitle: /*#__PURE__*/_jsx(ValidI18nMessage, {
            defaultValue: collectionTagline,
            message: `marketplace-assets-ui.collections.collection_${collectionId}.tagline`
          }),
          title: /*#__PURE__*/_jsx(ValidI18nMessage, {
            defaultValue: collectionTitle,
            message: `marketplace-assets-ui.collections.collection_${collectionId}.title`
          }),
          titleControls: /*#__PURE__*/_jsx(CollectionRouter, {
            linkTo: linkTo,
            linkText: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.storefront.home.exploreCollection",
              options: {
                title: validUnescapedText(`marketplace-assets-ui.collections.collection_${collectionId}.title`, {}, collectionTitle)
              }
            }),
            trackInteraction: trackInteraction
          }),
          trackInteraction: trackCollectionInteraction,
          trackPageview: trackCollectionPageview,
          searchQuery: searchQuery
        });
      }

      return /*#__PURE__*/_jsx("div", {});
    }
  });
};

export default CollectionSection;